export const environment = {
  production: false,
  url: "https://uat-lenda-api-motor.policystreet.app",
  crmUrl: "https://uat-lenda-api-crm.policystreet.app",
  signalrHubUrl: "https://uat-lenda-crm.policystreet.app/hub",
  googleTagId: "",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
  grabMiniApp: {
    clientId: 'e4e4ed59bfd74f499329d42873b4a29b',
    redirectUri: 'https://grabc.policystreet.app/grab/oauth/authentication-callback',
    webviewUrl: 'https://api.stg-myteksi.com',
    env: 'staging'
  },
};
